import styled from 'styled-components';
import { colorCSS } from '../../styles';
export const BannerContainer = styled.div `
  background-color: ${colorCSS('N0')};
  border-top: 1px solid ${colorCSS('N40')};
  box-shadow: rgba(0, 0, 0, 0.3) 0px 0px 10px 0px;
  font-size: 1rem;
  padding: 1rem 2.5rem;
  position: fixed;
  bottom: 0;
  width: 100%;
  text-align: center;
  z-index: 1;
  p {
    margin: 0 auto;
    margin-bottom: 1rem;
    max-width: 1140px;
  }
  button {
    color: ${colorCSS('B400')};
    font-size: 1rem;
  }
`;
export const CloseButton = styled.button `
  appearance: none;
  background: transparent;
  border: none;
  position: absolute;
  top: 0;
  right: 0;
`;
//# sourceMappingURL=UiCookieBanner.styles.js.map